import { IExamPool } from "@tsin-core/models/exam.model";
import { IExaminersReq, ISendAvailabilityEmailInput, IUpdateAvailabilityInput } from "@tsin-core/models/examiner.model";


const ACTION_SCOPE = '[Examiner]';

export class CreateExaminer {
  static readonly type = `${ACTION_SCOPE} Create Examiner`;
  constructor(public payload: any) { }
}

export class GetExaminers {
  static readonly type = `${ACTION_SCOPE} Get Examiner`;
  constructor(public payload: IExaminersReq) { }
}

export class GetExaminersAvaliability {
  static readonly type = `${ACTION_SCOPE} Get Examiners Avaliability`;
  constructor(public payload: string) { }
}

export class UpdateExaminer {
  static readonly type = `${ACTION_SCOPE} Update Examiner`;
  constructor(public updatePayload: any) { }
}

export class DeleteExaminer {
  static readonly type = `${ACTION_SCOPE} Delete Examiner`;
  constructor(public id: string) { }
}

export class ClearExaminers {
  static readonly type = `${ACTION_SCOPE} Clear Examiner`;
}

export class SetLoading {
  static readonly type = `${ACTION_SCOPE} Set Loading`;
  constructor(public loading: boolean) { }
}

export class SetError {
  static readonly type = `${ACTION_SCOPE} Set Error`;
  constructor(public error: string | null) { }
}

export class SendAvailabilityEmail {
  static readonly type = `${ACTION_SCOPE} send email`;
  constructor(public input: ISendAvailabilityEmailInput) { }
}

export class UpdateAvailability {
  static readonly type = `${ACTION_SCOPE} update avail`;
  constructor(public input: IUpdateAvailabilityInput) { }
}

export class UpdateExaminerStatus {
  static readonly type = `${ACTION_SCOPE} Update Examiner Shortlisted Status`;
  constructor(public payload: {examinerId: string, status: string}) { }
}

export class CreateExamPool {
  static readonly type = `${ACTION_SCOPE} Create Examiner Pool`;
  constructor(public payload: IExamPool) { }
}

export class ExaminerSignInOut {
  static readonly type = `${ACTION_SCOPE} Examiner Sign In Out`;
  constructor(public payload: any) { }
}

export class GetExaminerSignInAction{
  static readonly type = `${ACTION_SCOPE} Get Examiner Sign In History`;
  constructor(public payload: any) { }
}

export class GetAssignedExaminers {
  static readonly type = `${ACTION_SCOPE} Get Assigned Examiners`;
  constructor(public examId: string, public examType: string = 'Examiner') { }
}


export class GetExaminerByUserId {
  static readonly type = `${ACTION_SCOPE} Get Examiner by User Id`;
  constructor(public payload: string) { }
}


export class EmptyAssignedExaminers {
  static readonly type = `${ACTION_SCOPE} Empty Assigned Examiners`;
  constructor() { }
}

